import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {FilterUtil} from '../../../util/filter.util';
import {RequestType} from '../../../enums/request.type';
import {ListResponse} from '../../../network/service/list.response';
import {SnackBarUtil} from '../../../util/snack.bar.util';
import {VerifyOptions} from '../../dialog/verify/options/verify.options';
import {VerifyComponent} from '../../dialog/verify/verify.component';
import {DataResponse} from '../../../network/service/data.response';
import {AddOrUpdateSpacesOptions} from '../dialog/add-or-update-spaces/options/add-or-update-spaces.options';
import {AddOrUpdateSpacesComponent} from '../dialog/add-or-update-spaces/add-or-update-spaces.component';
import {ChairsOptions} from "../dialog/chairs/options/chairs.options";
import {ChairsComponent} from "../dialog/chairs/chairs.component";
import {QrCodeOptions} from "../dialog/qr-code/options/qr-code.options";
import {QrCodeComponent} from "../dialog/qr-code/qr-code.component";

@Component({
  selector: 'app-spaces',
  standalone: false,
  templateUrl: './spaces.component.html',
  styleUrl: './spaces.component.scss'
})
export class SpacesComponent extends BaseComponent implements OnInit {
  displayedColumns = ['Update', 'Delete', 'Chairs', 'QRCode', 'Title', 'IsActive'];
  displayDataSources = ['edit', 'delete', 'event_seat', 'qr_code', 'Title', 'IsActiveIcon'];
  displayColumnTypes = ['event', 'event', 'event', 'event', 'string', 'icon'];
  displayEndPoint = ['', ''];
  spaces: any = [];
  allFilters = FilterUtil.DeliveryMethodsFilters;
  filters: any = {};

  constructor(injector: Injector) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline() {
    super.loadOnline();
    if (!this.filters.Values) {
      this.filters.Values = [];
    }
    this.filters.Values.push({
      Field: 'Type',
      Type: 'EQ',
      Value: 'TABLE'
    });
    this.serviceApi.getSpaces(this.tableProperties.offset, this.tableProperties.limit, 'Business', RequestType.PAGINATE, undefined, {
      Filter: this.filters,
    }).subscribe((res: ListResponse<any>) => {
      if (res.success) {
        this.spaces = res.data;
        this.tableProperties.pageLength = res.count;
        this.setListeners();
      } else {
        SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
      }
    });
  }

  override setListeners() {
    super.setListeners();
    if (this.spaces) {
      for (let i = 0; i < this.spaces.length; i++) {
        this.spaces[i].edit = (index: number) => {
          this.onUpdateClicked(index);
        };
        this.spaces[i].delete = (index: number) => {
          this.onDeleteClicked(index);
        };
        this.spaces[i].event_seat = (index: number) => {
          this.onChairsSelected(index);
        };
        this.spaces[i].qr_code = (index: number) => {
          this.onQrCodeSelected(index);
        };
        if (this.spaces[i].IsActive === true) {
          this.spaces[i].IsActiveIcon = 'check_circle-green';
        } else {
          this.spaces[i].IsActiveIcon = 'do_not_disturb-red';
        }
      }
    }
  }

  override pageChanged(event: any) {
    super.pageChanged(event);
    this.tableProperties.offset = (event.pageIndex);
    this.loadOnline();
  }

  override onSortChanged(event: any) {
    super.onSortChanged(event);
    this.loadOnline();
  }

  onFiltersChanged(filters: any) {
    this.filters = filters;
    this.tableProperties.offset = 0;
    this.loadOnline();
  }

  onCreateClicked() {
    let addOrUpdateSpacesOption = new AddOrUpdateSpacesOptions();
    addOrUpdateSpacesOption.space = {};
    addOrUpdateSpacesOption.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateSpacesComponent = this.matDialog.open(AddOrUpdateSpacesComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateSpacesComponent.componentInstance.addOrUpdateSpacesOptions = addOrUpdateSpacesOption;
  }

  onUpdateClicked(index: number) {
    let addOrUpdateSpacesOption = new AddOrUpdateSpacesOptions();
    addOrUpdateSpacesOption.space = this.spaces[index];
    addOrUpdateSpacesOption.onInsertOrUpdateFinished = () => {
      this.loadOnline();
    };
    let addOrUpdateSpacesComponent = this.matDialog.open(AddOrUpdateSpacesComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    addOrUpdateSpacesComponent.componentInstance.addOrUpdateSpacesOptions = addOrUpdateSpacesOption;
  }

  onChairsSelected(index: number) {
    let chairsOptions = new ChairsOptions();
    chairsOptions.spaceId = this.spaces[index].SpaceId;
    chairsOptions.businessId = this.spaces[index].BusinessId;
    let chairsComponent = this.matDialog.open(ChairsComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    chairsComponent.componentInstance.chairsOptions = chairsOptions;
  }

  onQrCodeSelected(index: number) {
    let qrCodeOptions = new QrCodeOptions();
    qrCodeOptions.space = this.spaces[index];
    let qrCodeComponent = this.matDialog.open(QrCodeComponent, {
      height: 'auto',
      width: '100%',
      direction: "rtl"
    });
    qrCodeComponent.componentInstance.qrCodeOptions = qrCodeOptions;
  }

  onDeleteClicked(index: number) {
    let verifyOptions = new VerifyOptions();
    verifyOptions.message = 'آیا از حذف درخواست خود مطمئن هستید؟';
    let verifyComponent = this.matDialog.open(VerifyComponent);
    verifyOptions.onNoClicked = () => {
      verifyComponent.close();
    };
    verifyOptions.onYesClicked = () => {
      this.serviceApi.deleteSpaces(this.spaces[index].SpaceId).subscribe((res: DataResponse<any>) => {
        if (res.success) {
          verifyComponent.close();
          this.loadOnline();
        } else {
          SnackBarUtil.makeMessage(this, this.translateService.instant(res.message!), res.success, res.data);
        }
      });
    };
    verifyComponent.componentInstance.verifyOptions = verifyOptions;
  }
}
